module.exports = __webpack_public_path__ + "static/media/003.1b1e676d.jpg";